import { COLORS } from '../../../constants';

const styles = theme => {
  const minSm = theme.breakpoints.up('sm');

  return {
    cardRoot: {
      borderRadius: 0,
      [minSm]: {
        borderRadius: 4,
      },
    },
    cardHeaderRoot: {
      backgroundColor: COLORS.GREY_DARK,
      [minSm]: {
        paddingLeft: 30,
        paddingRight: 30,
      },
    },
    cardHeaderTitle: {
      color: COLORS.WHITE,
      textAlign: 'center',
      fontSize: '1.25rem',
      fontWeight: 600,
    },
    cardContentRoot: {
      [minSm]: {
        paddingLeft: 30,
        paddingRight: 30,
      },
    },
  };
};

export default styles;
